module.exports = __webpack_public_path__ + "static/media/the-wheel.9016c4e3.png";